import { getZonedDate } from '@eika-infrastruktur/date';

import type { EFakturaPaymentRequest } from '../../../generated-types';
import { payEfaktura } from '../../../services/eFakturaService';
import nullableZonedDateToUtc from '../../../utils/mapper/nullableZonedDateToUtc';
import { EfakturaState } from './form/state';

export default () => (eFakturaState: EfakturaState) => {
    const paymentDate = eFakturaState.paymentDate ?? getZonedDate();
    const request: EFakturaPaymentRequest = {
        fromAccountNumber: eFakturaState.fromAccount!,
        toAccount: eFakturaState.toAccount!.accountNumber,
        amount: eFakturaState.amount!,
        currency: 'NOK',
        kid: eFakturaState.kid,
        text: eFakturaState.note,
        paymentDate: nullableZonedDateToUtc(paymentDate)!,
    };

    return payEfaktura(eFakturaState.efakturaId!, request, eFakturaState.acceptDuplicate);
};
